<template>
	<v-card class="mb-1" :color="color" :dark="dark">
    <v-container>
      <v-row>
        <v-col
        	cols="12"
        	class="text-center"
        	lg="2"
        	sm="3"
        	:order="inverseOrder?'last':'first'"
        >
        	<slot name="prepend"></slot>
        </v-col>
        <v-col
        	cols="12"
          lg="10"
          sm="9"
          :class="inverseOrder? 'text-right': 'text-left'"
          :order="inverseOrder?'first':'last'"
        >
          <slot name="body"></slot>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: 'InfoDisplay',
  props:{
  	inverseOrder:{
  		type: Boolean,
  		default: false
  	},
  	color:{
  		type: String,
  		default: 'siiNaranjo'
  	},
  	dark:{
  		type:Boolean,
  		default: false
  	}
  },
  data () {
    return {

    }
  }
}
</script>

<style lang="css" scoped>
</style>